import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
import Swal from "sweetalert2";
import { getStoredValue, setStoredValue, removeStoredValue } from "../../src/_helpers/storageHelper";
// import { fetchWrapper } from "../_helpers/fetch-wrapper";

// create slice

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    isPageReload: 0,
    isSignalRData : '',
    connectionData: '',
    ECardloadMoreCount: 0,
    error: null,
    IP:""
  };
}

function createReducers() {
  return {
    logout,
    updateLocation,
    updateSignalRData,
    updateconnectionData,
    updateScroll
  };

  function logout(state) {
    const storedloginResponse = getStoredValue("loginResponse");
    var oldsignalRId = getStoredValue(`signalRId_${storedloginResponse?.InmateID}`);
    if (oldsignalRId && state?.connectionData?._connectionState == "Connected") {
      state?.connectionData.invoke("RemoveUser", oldsignalRId.toString())
    }
    Swal.close(); removeStoredValue("loginResponse");  removeStoredValue('lang');
    removeStoredValue('PodSharedStatus'); removeStoredValue(`signalRId_${storedloginResponse?.InmateID}`);
    history.navigate("/"); window.location.reload();
  }

  function updateLocation(state, action) {
    state.isPageReload = action.payload && action.payload;
  }

  function updateSignalRData(state, action) {
    state.isSignalRData = action.payload && action.payload;
  }

   function updateconnectionData(state, action) {
    state.connectionData = action.payload && action.payload;
  }

  function updateScroll(state, action) {
    state.ECardloadMoreCount = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/LoginUser`;
  const commonUrl =  `${process.env.REACT_APP_API_URL}`;

  return {
     GetIPAddress : GetIPAddress()
  };

  function GetIPAddress() {
    return createAsyncThunk(
      `${name}/GetIPAddress`,
      async () =>
        await fetchWrapper.get(`${commonUrl}/Common/GetIPAddress`)
    );
  }

}

function createExtraReducers(builder) {
  builder   
     .addCase(extraActions.GetIPAddress.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.GetIPAddress.fulfilled,
      (state, action) => {
        state.IP = action.payload;
        if(action.payload?.IpAddress){
          setStoredValue("cachedIP", action.payload?.IpAddress);
        }
      }
    )
    .addCase(
      extraActions.GetIPAddress.rejected,
      (state, action) => {
        state.error = action.error;
      }
    );
}